import { toggle } from "../utils/ui-helpers.js";
import { showModal } from "./ui.js";

export function showSessionExpiredModal() {
    const modalTitle = "We're sorry"
    const bodyHTML = sessionBodyMarkup();

    let timeTilReload = 3000;
    const secondInMillisecs = 1000;

    showModal(
        modalTitle, 
        bodyHTML, 
        { 
            buttonCallback: () => {                           
                toggle(document.getElementById('page-reload-timer'), true, 'flex');                
                const timerText = document.getElementById('time-til-reload');                
                countDownToReload(timerText, timeTilReload / secondInMillisecs);
                setTimeout(function() {
                    location.reload();
                }, timeTilReload);
            },
            buttonOpts:  {},
            buttonText: 'Refresh page',
            doHideOnClick: false
        }
    )
}

function countDownToReload(sessionExpiryText, initialTimeInSecs) {
    sessionExpiryText.textContent = initialTimeInSecs;

    setTimeout(() => {
        countDownToReload(sessionExpiryText, initialTimeInSecs - 1);
    }, 1000);        
}

function sessionBodyMarkup() {
    return `
        <p id='session-expiry-text'>
            Your booking session has expired. \n\n If you would still like to book, please refresh the page and try again.
        </p>
        <div id='page-reload-timer' style='display: none'>
            <span class='me-1'>Restarting in:</span> <span id='time-til-reload' class='fw-semibold'></span>
        </div>`;
}